module.exports = __webpack_public_path__ + "img/settings_voice.a5b79756.svg";